import v8n from 'v8n'

// ※正規表現はeslintのチェックを回避する為、スペースと一部記号は16進数で記述すること
v8n.extend({
  matchPassword: expected => {
    return value => value === expected
  },
  alpha: () => {
    return value => value.match(/^[a-zA-Z]*$/)
  },
  alphanum: () => {
    return value => value.match(/^[0-9a-zA-Z]*$/)
  },
  num: () => {
    return value => value.match(/^[0-9]*$/)
  },
  float: () => {
    return value => value !== '' ? value.match(/^[-]?([1-9]\d*|0)(\.\d+)?$/) : true
  },
  float6: () => {
    return value => value !== '' ? value.match(/^[-]?([1-9]\d*|0)\.[0-9]{1,6}$/) : true
  },
  email: () => {
    return value => value.match(/^[a-zA-Z0-9.!#$%&\x27*+\x2f=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*(\.[a-zA-Z0-9]+)$/)
  },
  zenkana: () => {
    return value => value.match(/^[ァ-ヶー\u3000]*$/)
  },
  zenhira: () => {
    return value => value.match(/^[ぁ-んー\u3000]*$/)
  },
  hankana: () => {
    return value => value.match(/^[ｦ-ﾟ]*$/)
  },
  zenkaku: () => {
    return value => value.match(/^[^\x20-\x7e]*$/)
  },
  hankaku: () => {
    return value => value.match(/^[\x20-\x7e]*$/)
  },
  noalpha: () => {
    return value => !value.match(/[a-zA-Z]/)
  },
  nonumber: () => {
    return value => !value.match(/[0-9]/)
  },
  nohankana: () => {
    return value => !value.match(/[ｦ-ﾟ]/)
  },
  nospace: () => {
    return value => !value.match(/[\x20\u3000]/)
  },
  nohanspace: () => {
    return value => !value.match(/[\x20]/)
  },
  noallsign: () => {
    return value => !value.match(/[!"#$%&'()\x2a\x2b\x2e\x2d\x2f,:;<=>?@\x5b\x5c\x5d^_`{|}~]/g)
  },
  nosign: () => {
    return value => !value.match(/[!"#$%&'()\x2a\x2b,;<=>?@\x5b\x5c\x5d^_`{|}~]/g)
  },
  nodot: () => {
    return value => !value.match(/[\x2e]/g)
  },
  nohyphen: () => {
    return value => !value.match(/[\x2d]/g)
  },
  noslash: () => {
    return value => !value.match(/[\x2f]/g)
  },
  nocolon: () => {
    return value => !value.match(/[:]/g)
  },
  nozenkana: () => {
    return value => !value.match(/[ァ-ヶ]/)
  },
  nozenhira: () => {
    return value => !value.match(/[ぁ-ん]/)
  },
  nozenspace: () => {
    return value => !value.match(/[\u3000]/)
  }
})

export default {
  setup (props) {
    let isValidated = null
    let invalidRule = ''
    return {
      isValidated,
      invalidRule
    }
  },
  computed: {
    state () {
      // エラー表示判定
      return this.disperror ? this.isValidated : null
    },
    invalidFeedback () {
      // エラーメッセージの設定
      return this.invalidRule
    }
  },
  methods: {
    inputValue (v) {
      this.$emit('input', v)
    },
    updateValue (v) {
      let value = v
      // if (typeof v === 'boolean') {
      //   value = (v) ? 1 : 0
      // }
      // 値が更新された時に親にvalue値を送信
      this.validate(value)
      this.$emit('input', value)
      // this.$emit('updateValue', {fieldname: this.fieldname, value: value, validate: this.isValidated})
      this.$emit('updateValue', {fieldname: this.id, value: value, validate: this.isValidated})
    },
    setInvaidated (messageId) {
      this.invalidRule = this.$t(messageId)
      this.isValidated = false
    },
    resetInvaidated () {
      this.invalidRule = ''
      this.isValidated = true
    },
    changeNumber (v) {
      if (typeof v === 'string') {
        return Number(v)
      }
      return v
    },
    validate (v) {
      let vobj = v8n()
      let value = !v ? '' : typeof v !== 'string' ? String(v) : v
      // console.log(value, typeof v, this.validators)
      if (this.validators) {
        if (this.validators[0] === 'any') {
          console.log()
          let anyobj = v8n()
          if (anyobj.empty().test(value)) {
            this.invalidCode = ''
            return true
          }
        }
        this.validators.forEach((vmethod) => {
          // console.log(vmethod, value, v)
          if (vmethod === 'required') vobj = vobj.not.empty()
          if (vmethod === 'minlength') vobj = vobj.minLength(this.minlength)
          if (vmethod === 'maxlength') vobj = vobj.maxLength(this.maxlength)
          if (vmethod === 'matchPassword') vobj = vobj.matchPassword(this.refvalue)
          if (vmethod === 'alpha') vobj = vobj.alpha()
          if (vmethod === 'alphanum') vobj = vobj.alphanum()
          if (vmethod === 'number') vobj = vobj.num()
          if (vmethod === 'float') vobj = vobj.float()
          if (vmethod === 'float6') vobj = vobj.float6()
          if (vmethod === 'zenkana') vobj = vobj.zenkana()
          if (vmethod === 'zenhira') vobj = vobj.zenhira()
          if (vmethod === 'zenkaku') vobj = vobj.zenkaku()
          if (vmethod === 'hankaku') vobj = vobj.hankaku()
          if (vmethod === 'hankana') vobj = vobj.hankana()
          if (vmethod === 'noalpha') vobj = vobj.noalpha()
          if (vmethod === 'nonumber') vobj = vobj.nonumber()
          if (vmethod === 'nospace') vobj = vobj.nospace()
          if (vmethod === 'noallsign') vobj = vobj.noallsign()
          if (vmethod === 'nosign') vobj = vobj.nosign()
          if (vmethod === 'nodot') vobj = vobj.nodot()
          if (vmethod === 'nohyphen') vobj = vobj.nohyphen()
          if (vmethod === 'noslash') vobj = vobj.noslash()
          if (vmethod === 'nocolon') vobj = vobj.nocolon()
          if (vmethod === 'nozenkana') vobj = vobj.nozenkana()
          if (vmethod === 'nozenhira') vobj = vobj.nozenhira()
          if (vmethod === 'nohankana') vobj = vobj.nohankana()
          if (vmethod === 'nozenspace') vobj = vobj.nozenspace()
          if (vmethod === 'nohanspace') vobj = vobj.nohanspace()
          if (vmethod === 'email') vobj = vobj.email()
        })
        try {
          vobj.check(value)
          this.isValidated = true
          this.invalidCode = ''
        } catch (error) {
          // console.log(error.rule.name, error.rule.args)
          let messageId = 'VALIDATE.' + error.rule.name
          this.invalidRule = this.$t(messageId, error.rule.args)
          this.isValidated = false
        }
        // console.log(this.invalidFeedback)
      } else {
        this.isValidated = true
      }
      return this.isValidated
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/commonValidate.js